// removed by extract-text-webpack-plugin
module.exports = {"portfolioHead":"_1Cz97BTIFX_4yoJzkNh1Jt","splash":"_1w1I1GOKmVRA6R4KEiBSt3","infoBanner":"JiCZH4enCUmJfn7ZNt7hJ","seconInfoBanner":"wKMIVqDHN-wIEkPqSPHTr","label":"_1yax6ToHnYbEqNZPdsDfOA","field":"_1bwNxEBDFDbtP07MUyqEts"};


/*****************
 ** WEBPACK FOOTER
 ** ../components/PortfolioHead.module.scss
 ** module id = 1766
 ** module chunks = 0
 **/